import { FC } from "react";
import { Text } from "@chakra-ui/react";

import { CaseDocumentModel } from "@shared/models";
import { CaseDocumentActions } from "@containers/Cases/interface";
import { pluralize } from "@containers/Cases/utils/caseDocuments";

import ActionLink from "./CaseDocumentActionLink";
import CaseDocumentProgressBar from "./CaseDocumentProgressBar";
import { getParsingPhase, getParsingProgress } from "./CaseDocuments.utils";
import CaseDocumentCardFrame from "./CaseDocumentCardFrame";
import CaseDocumentCardActions from "./CaseDocumentCardActions";

interface CaseDocumentParsingCardProps {
  caseDocument: CaseDocumentModel;
  actions: CaseDocumentActions;
}

const CaseDocumentParsingCard: FC<CaseDocumentParsingCardProps> = ({ caseDocument, actions: { showResult } }) => (
  <CaseDocumentCardFrame caseDocument={caseDocument} gap="12px">
    <CaseDocumentProgressBar value={getParsingProgress(caseDocument)} />
    <Text fontSize="13px" lineHeight={1.5} color="brand.emptyStateText">
      {pluralize(caseDocument.files.length, "file")} · {getParsingPhase(caseDocument)}. This keeps running if you leave
      or refresh the page.
    </Text>
    <CaseDocumentCardActions>
      <ActionLink disabled={!showResult} onClick={() => showResult?.(caseDocument.kind)}>
        Show progress
      </ActionLink>
    </CaseDocumentCardActions>
  </CaseDocumentCardFrame>
);

export default CaseDocumentParsingCard;
